/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Send_ButtonInputs */

const en_chat_send_button = /** @type {(inputs: Chat_Send_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

const fr_chat_send_button = /** @type {(inputs: Chat_Send_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer`)
};

const ms_sg2_chat_send_button = /** @type {(inputs: Chat_Send_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantar`)
};

/**
* | output |
* | --- |
* | "Send" |
*
* @param {Chat_Send_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_send_button = /** @type {((inputs?: Chat_Send_ButtonInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Send_ButtonInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_send_button(inputs)
	if (locale === "fr") return fr_chat_send_button(inputs)
	return ms_sg2_chat_send_button(inputs)
});